<template>
  <div class="checkout-content-block">
    <div class="checkout">
      <b-row>
        <b-col md="12">
          <div class="checkout__step">
            <div class="checkout__step-item">
              <vb-icon class="checkout__step-symbol" :name="'check'" :color="'ffffff'" :size="16" />
              <router-link class="checkout__step-label" :to="{name: 'detail'}">Scelta camere</router-link>
            </div>
            <div class="checkout__step-item">
              <span class="checkout__step-symbol">2</span>
              <span class="checkout__step-label">Ultimo step</span>
            </div>
          </div>
        </b-col>
        <template v-for="(block,key) in checkout_blocks">
          <component
            v-if="block.show"
            :key="_uid+block+key"
            :is="block.key"
            :hotel="hotel"
            :solution="solution"
          />
        </template>
      </b-row>
    </div>
  </div>

</template>

<script>
import Hotel from '@bookingv3/components/blocks/checkout/hotel'
import Reservation from '@bookingv3/components/blocks/checkout/reservation'
import Accommodations from '@bookingv3/components/blocks/checkout/accommodations'
import Conditions from '@bookingv3/components/blocks/checkout/conditions'
import Info from '@bookingv3/components/blocks/checkout/info'
import Comments from '@bookingv3/components/blocks/checkout/comments'

export default {
  name: 'checkout-content-block',

  components: {
    'hotel': Hotel,
    'reservation': Reservation,
    'accommodations': Accommodations,
    'conditions': Conditions,
    'info': Info,
    'comments': Comments,
  },

  props: {
    solution: Object,
    hotel: Object,
  },

  data() {
    return {
      checkout_blocks: [],
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
    this.checkout_blocks = [
      {
        key: "hotel",
        show: true,
      },
      {
        key: "reservation",
        show: true,
      },
      {
        key: "accommodations",
        show: true,
      },
      {
        key: "conditions",
        show: true,
      },
      {
        key: "comments",
        show: true,
      },
      {
        key: "info",
        show: true,
      },
    ]
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .checkout {

    &__step {
      $this_step : &;
      background-color: $white;
      border-radius: 10px;
      padding: 15px 20px;
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: $grid-gutter-width*2;

      &:before {
        content: '';
        position: absolute;
        top: 3px;
        left: 175px;
        right: 57.5%;
        bottom: 0;
        margin: auto;
        height: 1px;
        background-color: $gray-200;
        display: none;

        @include media-breakpoint-up(lg) {
          display: block;
        }
      }

      &-item {
        display: flex;
        align-items: center;
        flex-basis: 50%;

        @include media-breakpoint-up(sm) {
          flex-basis: 33%;
        }

        &:last-child {
          justify-content: center;
        }
      }

      &-symbol {
        background-color: $primary;
        border-radius: 50px;
        width: 25px;
        height: 25px;
        color: $white;
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-label {
        font-weight: $vb-font-weight-semibold;
        margin-left: 10px;

        @at-root #{$this_step}-item:first-child & {
          text-decoration: underline;

        }
      }
    }
  }

</style>